import { ItemContainerCreator } from "./item-container-creator";
import { GraphicGrid, FixedDimension, PercentDimension } from "../../../../../web-graphics";

export class GridCreator extends ItemContainerCreator {
  constructor(commonSettings) {
    super(commonSettings);
  }

  static prepareSettings(settings) {
    settings.location = {
      x: settings.x?.copy() ?? new FixedDimension(0),
      y: settings.y?.copy() ?? new FixedDimension(0)
    };
    settings.size = {
      width: settings.width?.copy() ?? new PercentDimension(1),
      height: settings.height?.copy() ?? new PercentDimension(1)
    };
    settings.parent = {
      ref: settings._parentObject
    };
    for (let rowIndex = 0; rowIndex < settings.rows.length; rowIndex++) {
      const rowSettings = settings.rows[rowIndex];
      if (rowSettings.height === undefined) {
        rowSettings.height = new PercentDimension(1);
      }
      if (rowSettings.columnsSpace === undefined) {
        rowSettings.columnsSpace = new FixedDimension(0);
      }
      for (let columnIndex = 0; columnIndex < rowSettings.columns.length; columnIndex++) {
        const columnSettings = rowSettings.columns[columnIndex];
        if (columnSettings.width === undefined) {
          columnSettings.width = new PercentDimension(1);
        }
      }
    }
  }

  static createItems(rowsSettings, viewObjectCreators, gridObject, canvasObject, idGenerator, creator) {
    if (rowsSettings === undefined || !Array.isArray(rowsSettings)) {
      return;
    }
    let calllbackArray = creator.callbacks.get("beforeAddItems");
    calllbackArray.forEach(callback => callback(gridObject, rowsSettings, creator));
    for (let rowIndex = 0; rowIndex < rowsSettings.length; rowIndex++) {
      const rowSettings = rowsSettings[rowIndex];
      const columns = rowSettings.columns ?? [];
      for (let columnIndex = 0; columnIndex < columns.length; columnIndex++) {
        ItemContainerCreator.createItem(
          columns[columnIndex].item,
          viewObjectCreators,
          gridObject.settings.rows[rowIndex].columns[columnIndex].panel,
          canvasObject,
          idGenerator,
          item => {
            gridObject.addItem(rowIndex, columnIndex, item);
          }
        );
      }
    }
  }

  create(settings) {
    let calllbackArray = this.callbacks.get("beforeCreate");
    calllbackArray.forEach(callback => callback(settings, this));
    GridCreator.prepareSettings(settings);
    const gridObject = new GraphicGrid(settings);
    GridCreator.createItems(settings.rows, settings._viewObjectCreators, gridObject, settings._canvasObject, settings._idGenerator, this);
    calllbackArray = this.callbacks.get("afterCreate");
    calllbackArray.forEach(callback => callback(gridObject, settings, this));
    return gridObject;
  }
}
